import { createAsyncThunk } from "@reduxjs/toolkit";
import { trackPromise } from "react-promise-tracker";
import { fetchWrapper } from "_utils";
import { PORTAL_KEY as name } from "constants/labels";
import { blobBrowserDownload } from "_utils/files/blobBrowserDownload";

const baseUrl = `${process.env.REACT_APP_API_URL_MAP_CENTER}/api/map-center`;
const baseURLAccount = `${process.env.REACT_APP_API_URL}/api/map-center`

/** Define thunks here */

export const getRequestTypeApi = createAsyncThunk(
  `${name}/getRequestType`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.get(`${baseUrl}/map-request/type`)
      );
      const { Succeeded, Errors, Message: message } = response;
      if (!Succeeded && Errors.length) throw new Error(message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getMCReqTypeApi = createAsyncThunk(
  `${name}/getMCReqType`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.get(`${baseUrl}/request-type`)
      );
      const { Succeeded, Errors, Message: message } = response;
      if (!Succeeded && Errors.length) throw new Error(message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCountyApi = createAsyncThunk(
  `${name}/getCounty`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.get(`${baseUrl}/map-request/county`)
      );
      const { Succeeded, Errors, Message: message } = response;
      if (!Succeeded && Errors.length) throw new Error(message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getStateApi = createAsyncThunk(
  `${name}/getState`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.get(`${baseUrl}/map-request/state`)
      );
      const { Succeeded, Errors, Message: message } = response;
      if (!Succeeded && Errors.length) throw new Error(message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const postMapRequestCreateApi = createAsyncThunk(
  `${name}/postMapRequestCreate`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/map-request/create`, { Data: payload })
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getMapRequestByIdApi = createAsyncThunk(
  `${name}/getMapRequestById`,
  async (mapReqId, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.get(`${baseUrl}/map-request/${mapReqId}`)
      );
      const { Succeeded, Errors, Message: message } = response;
      if (!Succeeded && Errors.length) throw new Error(message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getMapRequestApi = createAsyncThunk(
  `${name}/getMapRequest`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.get(`${baseUrl}/map-request`)
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getHistoryByIdApi = createAsyncThunk(
  `${name}/getHistoryById`,
  async (mapReqId, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.get(
          `${baseUrl}/map-request/interaction-history/${mapReqId}`
        )
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const postMapRequestFilterApi = createAsyncThunk(
  `${name}/postMapRequestFilter`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/map-request/filter`, { Data: payload })
      );
      const { Succeeded, Errors, Message: message } = response;
      if (!Succeeded && Errors.length) throw new Error(message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const postReviewMapRequestApi = createAsyncThunk(
  `${name}/postReviewMapRequestApi`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/map-request/process`, { Data: payload })
      );
      const { Succeeded, Errors, Message: message } = response;
      if (!Succeeded && Errors.length) throw new Error(message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const postReviewMapRequestStdUserApi = createAsyncThunk(
  `${name}/postReviewMapRequestStdUserApi`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/map-request/update-interaction-history`, { Data: payload })
      );
      const { Succeeded, Errors, Message: message } = response;
      if (!Succeeded && Errors.length) throw new Error(message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteMapRequestApi = createAsyncThunk(
  `${name}/deleteMapRequest`,
  async (mapRequestIds, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.delete(`${baseUrl}/map-request`, {
          MapReqIds: mapRequestIds,
        })
      );
      const { Succeeded, Errors, Message: message } = response;
      if (!Succeeded && Errors.length) throw new Error(message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getMapRequestDropdownDataFilterApi = createAsyncThunk(
  `${name}/getMapRequestDropdownDataFilter`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.get(`${baseUrl}/report/map-request-filters`)
      );
      
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getSecurityReviewDropdownDataFilterApi = createAsyncThunk(
  `${name}/getSecurityReviewDropdownDataFilter`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.get(`${baseUrl}/report/security-review-filters`)
      );
      const { Succeeded, Errors, Message: message } = response;
      if (!Succeeded && Errors.length) throw new Error(message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getStatusApi = createAsyncThunk(
  `${name}/getStatus`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.get(`${baseUrl}/map-request/status`)
      );
      const { Succeeded, Errors, Message: message } = response;
      if (!Succeeded && Errors.length) throw new Error(message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const postMapRequestReportApi = createAsyncThunk(
  `${name}/postMapRequestReport`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/report/map-request`, { Data: payload })
      );
      const { Succeeded, Errors, Message: message } = response;
      if (!Succeeded && Errors.length) throw new Error(message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const postSecurityReviewReportApi = createAsyncThunk(
  `${name}/postSecurityReview`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseUrl}/report/security-review`, {
          Data: payload,
        })
      );
      const { Succeeded, Errors, Message: message } = response;
      if (!Succeeded && Errors.length) throw new Error(message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getRegistrationDetailsApi = createAsyncThunk(
  `${name}/getRegistrationDetails`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.get(`${baseUrl}/registration/details`)
      );
      const { Succeeded, Errors, Message: message } = response;
      if (!Succeeded && Errors.length) throw new Error(message);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getInteractionHistoryDownloadApi = createAsyncThunk(
  `${name}/interactionHistoryDownloadApi1`,
  async (fileName, { rejectWithValue }) => {
    try {
      const { blob, headers } = await fetchWrapper.getFile(
        `${baseUrl}/map-request/download-file?fileName=${encodeURIComponent(
          fileName
        )}`
      );

      blobBrowserDownload(blob, headers, fileName);
      return true;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);


export const getMapRequestorsApi = createAsyncThunk(
  `${name}/getMapRequestors`,
  async (_, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.get(`${baseURLAccount}/manage-map-requestor`)
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);


export const createMapRequestorApi = createAsyncThunk(
  `${name}/createMapRequestor`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseURLAccount}/manage-map-requestor/create`, payload)
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);


export const updateMapRequestorApi = createAsyncThunk(
  `${name}/updateMapRequestor`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.post(`${baseURLAccount}/manage-map-requestor/update`, payload)
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);


export const deleteMapRequestorApi = createAsyncThunk(
  `${name}/deleteMapRequestor`,
  async (payload, { rejectWithValue }) => {
    try {
      const response = await trackPromise(
        fetchWrapper.delete(`${baseURLAccount}/manage-map-requestor/delete`, payload)
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
